import { useMemo } from 'react';
import { useValueProposalStore } from '../../../stores/prioritization/valueProposalStore';
import { agentProposerId } from '../../../lib/valueEstimatorRunner';

/** Every value this agent proposed that still waits for a person, newest first. */
export function useOpenValueProposals(agentType: string) {
  const proposals = useValueProposalStore((s) => s.proposals);
  return useMemo(
    () => proposals.filter((p) => p.proposedBy === agentProposerId(agentType) && p.status === 'proposed')
      .sort((a, b) => new Date(b.proposedAt).getTime() - new Date(a.proposedAt).getTime()),
    [proposals, agentType],
  );
}

